import { render } from "./TendenciasComp.vue?vue&type=template&id=320182a6&scoped=true"
import script from "./TendenciasComp.vue?vue&type=script&lang=js"
export * from "./TendenciasComp.vue?vue&type=script&lang=js"

import "./TendenciasComp.vue?vue&type=style&index=0&id=320182a6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320182a6"]])

export default __exports__